import { Redirect, useLocation } from 'react-router-dom';

import { routes } from '$src/routes';

export default function Home() {
  const { search } = useLocation();

  return (
    <Redirect
      to={{
        pathname: routes.locations,
        search,
      }}
    />
  );
}
